/**
 * Branch → auto-fill map, generated from the 2026-07-01 Agresso branches export.
 * Pick a branch in the expense line-entry form and these fields auto-fill
 * (they are 1:1 off branch in Agresso). Values mirror the `branch` coa_attribute.
 * Regenerate via scratchpad/gen_coa_seed.py — do not hand-edit.
 */
export interface BranchDefaults {
  productGroup: string;
  branchGroup: string;
  corSga: string;
}

export const BRANCH_DEFAULTS: Record<string, BranchDefaults> = {
  '702': {
    productGroup: 'Online',
    branchGroup: 'Operations Support',
    corSga: 'COR',
  },
  '720': {
    productGroup: 'Onsite',
    branchGroup: 'Operations Support',
    corSga: 'COR',
  },
  '721': {
    productGroup: 'Full Service',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '722': {
    productGroup: 'Full Service',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '730': {
    productGroup: 'Full Service',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '731': {
    productGroup: 'Full Service',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '732': {
    productGroup: 'Full Service',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '740': {
    productGroup: 'Full Service',
    branchGroup: 'Advisor Support',
    corSga: 'COR',
  },
  '741': {
    productGroup: 'Full Service',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '750': {
    productGroup: 'Platform Services',
    branchGroup: 'Operations Support',
    corSga: 'COR',
  },
  '751': {
    productGroup: 'Platform Services',
    branchGroup: 'Operations Support',
    corSga: 'COR',
  },
  '752': {
    productGroup: 'Platform Services',
    branchGroup: 'Client Management',
    corSga: 'SG&A',
  },
  '760': {
    productGroup: 'Hosted',
    branchGroup: 'Hosted Agency Support',
    corSga: 'COR',
  },
  '768': { productGroup: 'Groups', branchGroup: 'Advisors', corSga: 'COR' },
  '769': { productGroup: 'Groups', branchGroup: 'Advisors', corSga: 'COR' },
  '770': { productGroup: 'Groups', branchGroup: 'Advisors', corSga: 'COR' },
  '771': { productGroup: 'Events', branchGroup: 'Advisors', corSga: 'COR' },
  '775': {
    productGroup: 'Humanitarian',
    branchGroup: 'Advisors',
    corSga: 'COR',
  },
  '799': { productGroup: 'Motor City', branchGroup: 'Advisors', corSga: 'COR' },
  '800': { productGroup: '', branchGroup: 'Admin', corSga: 'SG&A' },
  '801': { productGroup: '', branchGroup: 'Admin', corSga: 'SG&A' },
  '802': { productGroup: '', branchGroup: 'Admin', corSga: 'SG&A' },
  '803': { productGroup: '', branchGroup: 'Admin', corSga: 'SG&A' },
  '810': { productGroup: '', branchGroup: 'Admin', corSga: 'SG&A' },
  '820': { productGroup: '', branchGroup: 'Operations', corSga: 'COR' },
  '830': { productGroup: '', branchGroup: 'Client Management', corSga: 'SG&A' },
  '831': { productGroup: '', branchGroup: 'Client Management', corSga: 'SG&A' },
  '832': { productGroup: '', branchGroup: 'Client Management', corSga: 'SG&A' },
  '840': { productGroup: '', branchGroup: 'Sales', corSga: 'SG&A' },
  '841': { productGroup: '', branchGroup: 'Marketing', corSga: 'SG&A' },
  '850': { productGroup: '', branchGroup: 'Product', corSga: 'SG&A' },
  '851': { productGroup: '', branchGroup: 'Product', corSga: 'SG&A' },
  '852': { productGroup: '', branchGroup: 'Product', corSga: 'SG&A' },
  '853': { productGroup: '', branchGroup: 'Operations', corSga: 'COR' },
  '870': { productGroup: '', branchGroup: 'Operations', corSga: 'COR' },
};
